export const FETCH_DELAY = 500 as const;

export const COMMON_FILTERS = {
    limit: 10,
    offset: 0,
    page: 1,
};
